import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { HomeOutlined, ArrowLeftOutlined } from "@ant-design/icons";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
            <div className="text-center p-5 shadow-lg rounded-4 bg-white" style={{ maxWidth: "500px", width: "100%" }}>

                {/* Big 404 */}
                <h1
                    style={{
                        fontSize: "90px",
                        fontWeight: "800",
                        background: "linear-gradient(135deg, #6366f1, #ec4899)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        marginBottom: "10px"
                    }}
                >
                    404
                </h1>

                {/* Title */}
                <h4 className="fw-bold mb-2">Oops! Page Not Found</h4>

                {/* Description */}
                <p className="text-muted mb-4">
                    The page you are looking for doesn’t exist or has been moved.
                </p>

                {/* Buttons */}
                <div className="d-flex justify-content-center gap-2">
                    <Button
                        type="primary"
                        icon={<HomeOutlined />}
                        size="large"
                        onClick={() => navigate("/")}
                    >
                        Go Home
                    </Button>

                    <Button
                        icon={<ArrowLeftOutlined />}
                        size="large"
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;